import React, { Component } from 'react'
import * as d3 from 'd3'
import moment from 'moment'
import _ from 'lodash'

import '../home/BarChart.css'
import { CHART_COLORS } from '../../util/chartPalette'

// ***** Default svg data
const defaultInfoHeight = 20
const defaultSvgWidth = 300
const defaultSvgHeight = 280
const defaultSvgMargin = {
  top: 20,
  right: 5,
  bottom: 40 + defaultInfoHeight,
  left: 30,
}
const defaultSvgScrollHeight = 40
const defaultPadding = 0.2
const defaultSliceWidth = 14
const defaultSelectorTopMargin = 20

class ActivityGraph extends Component {
  constructor(props) {
    super(props)

    const svgWidth = props.width === undefined ? defaultSvgWidth : props.width
    const svgHeight =
      props.height === undefined ? defaultSvgHeight : props.height
    const svgMargin =
      props.margin === undefined ? defaultSvgMargin : props.margin
    const svgScrollHeight =
      props.scrollHeight === undefined
        ? defaultSvgScrollHeight
        : props.scrollHeight
    const svgScrollMargin = { ...svgMargin, bottom: 0 }
    const padding = props.padding === undefined ? defaultPadding : props.padding
    const sliceWidth = props.bars === undefined ? defaultSliceWidth : props.bars
    const selectorTopMargin =
      props.selectorTopMargin === undefined
        ? defaultSelectorTopMargin
        : props.selectorTopMargin

    this.state = {
      svgWidth,
      svgHeight,
      svgMargin,
      svgScrollHeight,
      svgScrollMargin,
      padding,
      sliceStart: 0,
      sliceWidth,
      selectorTopMargin,

      xScale: d3
        .scaleBand()
        .range([svgMargin.left, svgWidth - svgMargin.right])
        .padding(padding),
      yScale: d3
        .scaleLinear()
        .range([
          svgHeight - svgMargin.bottom - svgScrollHeight - selectorTopMargin,
          svgMargin.top,
        ]),
      xAxisRef: null,
      yAxisRef: null,

      xScrollScale: d3
        .scaleBand()
        .range([svgScrollMargin.left, svgWidth - svgScrollMargin.right])
        .padding(padding),
      yScrollScale: d3
        .scaleLinear()
        .range([svgHeight, svgHeight - svgScrollHeight + svgScrollMargin.top]),
      scrollRef: null,

      scrollSelectorWidth: 0,
      scrollSelectorMinX: 0,
      scrollSelectorMaxX: 0,
      scrollBandWidth: 0,
      scrollSelectorX: 0,

      bars: [],
      scrollBars: [],
    }

    this.xAxis = d3
      .axisBottom()
      .scale(this.state.xScale)
      .tickFormat((d) => {
        return moment(d).format('MM/DD/YYYY')
      })
    this.yAxis = d3
      .axisLeft()
      .scale(this.state.yScale)
      .tickFormat(this.formatTicks)
  }

  formatTicks = (d) => {
    if (d % 1 == 0) {
      return d3.format(',.0f')(d)
    } else {
      return ''
    }
  }

  xAxisRef = (element) => {
    this.setState({ xAxisRef: element })
    d3.select(element)
      .call(this.xAxis)
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', 'rotate(-45)')
  }

  yAxisRef = (element) => {
    this.setState({ yAxisRef: element })
    d3.select(element).call(this.yAxis)
  }

  scrollRef = (element) => {
    this.setState({ scrollRef: element })
    d3.select(element).call(d3.drag().on('drag', this.scrollDrag))
  }

  scrollDrag = () => {
    let newX = this.state.scrollSelectorX + d3.event.dx
    let newSlice = 0
    const oldSlice = this.state.sliceStart

    if (newX > this.state.scrollSelectorMaxX) {
      newX = this.state.scrollSelectorMaxX
    } else if (newX < this.state.scrollSelectorMinX) {
      newX = this.state.scrollSelectorMinX
    }

    newSlice = newX - this.state.scrollSelectorMinX
    newSlice = Math.ceil(newSlice / this.state.scrollBandWidth)

    if (newSlice !== oldSlice) {
      const bars = this.calculateBars(newSlice)
      this.setState({ scrollSelectorX: newX, sliceStart: newSlice, bars })
    } else {
      this.setState({ scrollSelectorX: newX })
    }
  }
  checkWeekStatus = (date) => {
    const providedDate = moment(date)
    const sundayOfWeek = providedDate.day(0)
    const formattedDate = sundayOfWeek.format('MM/DD/YYYY')
    const week = this.props.summary.find(
      (summary) => summary.weekdate == formattedDate
    )
    if (_.isEmpty(week)) return false
    else {
      return week.totaldays == week.completeddays
    }
  }
  calculateBars = (newSliceStart) => {
    const { data } = this.props
    let { xScale, yScale, sliceStart, sliceWidth } = this.state

    if (newSliceStart !== undefined) {
      sliceStart = newSliceStart
    }

    const activityDomain = data
      .slice(sliceStart, sliceStart + sliceWidth)
      .map((d) => d.date)
    const valueMax = d3.max(data, (d) => d.total)

    xScale.domain(activityDomain)
    yScale.domain([0, valueMax])

    const bars = data
      .slice(sliceStart, sliceStart + sliceWidth)
      .map((d, index) => this.stackedBars(d, index))
    return bars
  }

  stackedBars = (data, index) => {
    let {
      xScale,
      yScale,
      svgHeight,
      svgMargin,
      svgScrollHeight,
      selectorTopMargin,
    } = this.state

    let stacks = []
    if (!data) return stacks
    //     const status=this.checkWeekStatus(data.date)
    //    if(status) return stacks
    const x = xScale(data.date)
    const width = xScale.bandwidth()
    let y = yScale(data.total)
    let height =
      svgHeight - svgMargin.bottom - svgScrollHeight - selectorTopMargin
    let stack1 = {
      index,
      x,
      y,
      height: height - (data.complete ? yScale(data.total - data.complete) : y),
      width,
      fill: 'white',
      value: data.total - data.complete,
    }
    //stacks.push(stack1)

    if (data.complete > 0) {
      let stack2 = {
        ...stack1,
        height: height - yScale(data.complete),
        y: yScale(data.complete),
        index: stack1.index + 1,
        fill: data.complete == data.total ? CHART_COLORS.completeGreen : CHART_COLORS.partialYellow,
        value: data.complete,
      }
      //if (data.complete == data.total) stacks.pop() // remove incomplete bar
      stacks.push(stack2)
      return stacks
    }

    return stacks
  }

  calculateScrollBars = () => {
    const { data } = this.props
    const { xScrollScale, yScrollScale, svgHeight } = this.state

    const scrollActivityDomain = data.map((d) => d.date)
    const valueMax = d3.max(data, (d) => d.total)

    xScrollScale.domain(scrollActivityDomain)
    yScrollScale.domain([0, valueMax])

    const scrollBars = data.map((d, index) => {
      const scrollX = xScrollScale(d.date)
      const scrollY = yScrollScale(d.total)
      const scrollWidth = xScrollScale.bandwidth()
      const scrollHeight = svgHeight - scrollY
      const scrollFill = '#cccccc'

      return {
        index,
        scrollX,
        scrollY,
        scrollWidth,
        scrollHeight,
        scrollFill,
      }
    })

    return scrollBars
  }

  calculateScrolSellector = (scrollBarsLength) => {
    const { sliceWidth, svgWidth, svgScrollMargin } = this.state

    const scaleWidth = svgWidth - svgScrollMargin.right - svgScrollMargin.left
    const scrollSelectorWidth = Math.floor(
      (sliceWidth / scrollBarsLength) * scaleWidth
    )
    const scrollSelectorMinX = svgScrollMargin.left
    const scrollSelectorMaxX =
      svgWidth - svgScrollMargin.right - scrollSelectorWidth
    const scrollBandWidth = Math.floor(scaleWidth / scrollBarsLength)

    return {
      scrollSelectorWidth,
      scrollSelectorMinX,
      scrollSelectorMaxX,
      scrollBandWidth,
      scrollSelectorX: scrollSelectorMaxX, // this line was manually added for bringing the selector to
      // the right most position when graph is loaded.
    }
  }

  calculateChart = () => {
    if (this.props.data === undefined) {
      return
    }

    /**
     * we have commented this line so that we can have new slice depending on the drag selector
     */
    // const bars = this.calculateBars();

    const scrollBars = this.calculateScrollBars()
    const selector = this.calculateScrolSellector(scrollBars.length)

    /**
     * we have calculated new slice so that we can see bars only for the new selector position
     */
    var newSlice = selector.scrollSelectorMaxX - selector.scrollSelectorMinX
    newSlice = Math.ceil(newSlice / selector.scrollBandWidth)
    const bars = this.calculateBars(newSlice)
    console.log(bars, 'barssssss', newSlice)
    const states = { ...selector, bars, scrollBars }

    this.setState(states)
  }

  componentDidMount = () => {
    this.calculateChart()
  }

  componentWillReceiveProps = ({ width, data }) => {
    if (this.props.width == width && this.props.data == data) return
    var { svgMargin, svgScrollMargin, padding } = this.state
    this.setState(
      {
        svgWidth: width,
        xScale: d3
          .scaleBand()
          .range([svgMargin.left, width - svgMargin.right])
          .padding(padding),
        xScrollScale: d3
          .scaleBand()
          .range([svgScrollMargin.left, width - svgScrollMargin.right])
          .padding(padding),
      },
      () => {
        this.xAxis = d3
          .axisBottom()
          .scale(this.state.xScale)
          .tickFormat((d) => moment(d).format('MM/DD/YYYY'))
        this.yAxis = d3
          .axisLeft()
          .scale(this.state.yScale)
          .tickFormat(this.formatTicks)
        this.calculateChart()
      }
    )
  }

  componentDidUpdate() {
    d3.select(this.state.xAxisRef)
      .call(this.xAxis)
      .selectAll('text')
      .style('text-anchor', 'end')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', 'rotate(-45)')
    d3.select(this.state.yAxisRef).call(this.yAxis)
  }

  renderInfo = () => {
    const { svgHeight, svgWidth, svgMargin } = this.state
    const yAnchor = svgHeight - svgMargin.bottom
    const xAnchor = (svgWidth / 2) * 0.3
    return (
      <g width={this.state.svgWidth}>
        <circle
          cx={xAnchor}
          cy={yAnchor}
          r={6}
          fill={CHART_COLORS.completeGreen}
          transform={`translate(10, 0)`}
        />
        <text
          x={xAnchor}
          y={yAnchor}
          height={defaultInfoHeight}
          transform={`translate(20, 0)`}
          dominantBaseline={'middle'}
        >
          All Completed
        </text>
        <circle
          cx={xAnchor}
          cy={yAnchor}
          r={5}
          fill={CHART_COLORS.partialYellow}
          stroke='black'
          strokeWidth={1}
          transform={`translate(120, 0)`}
        />
        <text
          x={xAnchor}
          y={yAnchor}
          height={defaultInfoHeight}
          transform={`translate(130, 0)`}
          dominantBaseline={'middle'}
        >
          Partially Completed
        </text>
      </g>
    )
  }

  render() {
    // console.log(this.props.data,"ddddddddddddddddd333")
    return (
      <svg
        width={this.state.svgWidth}
        height={this.state.svgHeight}
        className={this.props.isrotate ? 'activitysvg' : ''}
      >
        {this.state.bars.map((b, i) =>
          b.map((d, i) => (
            <>
              <rect
                key={i}
                x={d.x}
                y={d.y}
                width={d.width}
                height={d.height}
                fill={d.fill}
                style={{ strokeWidth: '1', stroke: 'rgb(0,0,0)' }}
              />
              <text
                x={d.x + d.width / 2}
                y={d.y + d.height / 2}
                dominantBaseline='middle'
                textAnchor='middle'
                fontSize={'12px'}
              >
                {d.value}
              </text>
            </>
          ))
        )}

        {this.state.scrollBars.map((d, i) => (
          <rect
            key={i}
            x={d.scrollX}
            y={d.scrollY}
            width={d.scrollWidth}
            height={d.scrollHeight}
            fill={d.scrollFill}
          />
        ))}

        <rect
          ref={this.scrollRef}
          className='scroll-selector'
          x={this.state.scrollSelectorX}
          y={this.state.svgHeight - this.state.svgScrollHeight}
          width={this.state.scrollSelectorWidth}
          height={this.state.svgScrollHeight}
        />

        <g>
          <g
            ref={this.xAxisRef}
            transform={`translate(0, ${
              this.state.svgHeight -
              this.state.svgMargin.bottom -
              this.state.svgScrollHeight -
              this.state.selectorTopMargin
            })`}
          />
          <g
            ref={this.yAxisRef}
            transform={`translate(${this.state.svgMargin.left}, 0)`}
          />
        </g>
        {this.renderInfo()}
      </svg>
    )
  }
}

export default ActivityGraph
